import React from "react";
import {ConfigProvider, Spin} from "antd"; // Import ConfigProvider
import {LoadingOutlined} from '@ant-design/icons';
import HeadingSkeleton from "../../../components/skeletons/HeadingSkeleton";

export default function TargetBoxSkeleton({
                                      GoalHeading,
                                      GoalEmptyHeading,
                                      GoalIcon,
                                      boxColor,
                                              iconColor,
                                      Color,
                                      backgroundColor,
                                      hasSwitch = false,
                                      children,
                                      data,
                                      loader
                                  }) {

    return (
        <ConfigProvider
            theme={{
                components: {
                    Checkbox: {
                        colorPrimary: "#D2A84E", // Main color for checkbox
                        colorPrimaryHover: "#FDFF9F", // Hover effect
                        borderRadius: 4,
                        controlHeight: 24
                    }
                }
            }}
        >
            <div className="goals-box">
                <div className="goals-box-header">
                    <h3 style={{ color: boxColor }}>
                        <HeadingSkeleton height={10} maxWidth={100} />
                    </h3>
                </div>
                <div className="goal-box-body" style={{ backgroundColor: backgroundColor }}>
                    <div className="goal-box-empty">
                        <div>
                            <Spin indicator={<LoadingOutlined style={{ fontSize: 55, color:iconColor }} spin />} />
                        </div>
                    </div>
                </div>
            </div>
        </ConfigProvider>
    );
}
